<template>
    <div class="tree-selectinput-wrapper" ref="wrapper">
        <div>
            <el-input
                ref="searchInput"
                @keyup.native="searchInTree"
                @focus="show"
                size="small"
                v-model="inputValue"
                :placeholder="placeholder"
                @click="clearText"
                :class="{ error: isError }"
                :disabled="disabled"
            >
                <i v-if="inputValue && !disabled" class="el-icon-close el-input__icon" slot="suffix" @click.stop="clearText"></i>
            </el-input>
        </div>
        <div class="float-box" v-show="visibility" v-loading="loading">
            <Tree
                v-show="hasSearchResult"
                ref="tree"
                :dataList="treeDataList"
                :onSelect="onSelect"
                :hasCheckbox="hasCheckbox"
                :hasControls="hasControls"
                :controls="controls"
                :hasCascadeSelect="hasCascadeSelect"
            ></Tree>
            <p v-if="!hasSearchResult" class="no-category-data">暂无结果</p>
        </div>
    </div>
</template>

<script>
import Tree from './Tree/Tree.vue';

export default {
    name: 'TreeSelectInput',
    components: {
        Tree
    },
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        dataList: Array,
        tree: Object,
        searchEnable: {
            type: Boolean,
            default: true
        },
        // 是否支持多选
        multiple: {
            type: Boolean,
            default: false
        },
        // 是否支持多选框
        hasCheckbox: {
            type: Function,
            default: () => {
                return false;
            }
        },
        beforeOnSelect: {
            type: Function
        },
        placeholder: {
            type: String,
            default: '请选择商品分类'
        },
        // value最佳设置为node节点中name属性值，可选为node节点的任意值
        value: [String, Number],
        // 是否校验值
        isValidate: {
            type: Boolean,
            default: false
        },
        // 校验不可为空的提醒
        requiredMsg: {
            type: String,
            default: '分类信息不可为空'
        },
        // 是否必须为叶子节点
        needLeaf: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            visibility: false, // 是否默认显示
            hasControls: function() {
                // 是否需要对树节点进行操作
                return false;
            },
            controls: [],
            hasCascadeSelect: false,
            treeDataList: [],
            selected: [],
            selectedText: '',
            inputValue: '',
            treeNode: null,
            loading: false,
            isError: false,

            hasSearchResult: true
        };
    },
    mounted() {
        if (this.multiple) {
            this.hasCheckbox = () => {
                return true;
            };
        }
        document.addEventListener('click', e => {
            if (!(this.$refs.wrapper && this.$refs.wrapper.contains(e.target))) {
                this.hide();
            }
        });

        this.setText();
    },
    watch: {
        value() {
            this.setText();
        }
    },
    methods: {
        searchInTree() {
            let tree = this.treeNode;
            clearTimeout(this.searchTimer);

            if (!this.treeDataList.length) {
                this.hasSearchResult = false;
                return;
            }

            if (this.inputValue) {
                this.loading = true;
                tree.travel(n => {
                    n.node.show = false;
                    n.node.open = false;
                    n.node.match = false;
                });
                this.searchTimer = setTimeout(() => {
                    let tempHasSearchResult = false;
                    tree.travel(n => {
                        let check = [n.name, n.pinyin, n.spell, n.simpleSpell, n.parsedName || ''].join('*').indexOf(this.inputValue) >= 0;
                        if (check) {
                            n.parent && (n.parent.node.open = check);
                            n.node.show = check;
                            // 遍历该节点的所有子节点,设置show为true
                            n.travel(n => {
                                n.node.show = check;
                            });
                            n.node.match = check;

                            tempHasSearchResult = true;
                        }
                    });
                    this.hasSearchResult = tempHasSearchResult;
                    this.loading = false;
                }, 2);
            } else {
                tree.reset();
                tree.$data.rootNode.node.open = true;
                this.hasSearchResult = true;
            }
        },
        onSelect(node) {
            // TBD树可多选时
            if (this.multiple) {
                let checkedList = [];
                this.treeNode.travel(treeNode => {
                    if (treeNode.node.checked === 2) {
                        checkedList.push(treeNode);
                        return false;
                    }
                });
                this.selected = checkedList;
            } else if (node) {
                if (this.beforeOnSelect(node)) {
                    this.selected = [node];
                    this.hide();
                    // 触发input事件，保持input事件传递id，以支持v-model的使用。
                    this.$emit('input', node.id);
                    // 添加选择节点select-node事件，用于传递node节点，实现多种传值和取值方式。
                    this.$emit('select-node', node);
                    this.$emit('validate', node);
                }
            }

            return this.selected;
        },
        setText() {
            // TBD,多选情况未处理
            if (!this.multiple) {
                let node = this.selected && this.selected[0];
                this.inputValue = (node && (node.parsedName || node.name)) || this.value || '';
            }
        },
        clearText() {
            this.init();
            this.$reset();
            this.$emit('select-node');
            this.$emit('validate');
        },
        init() {
            this.treeDataList = this.tree ? this.tree.getData() : this.dataList;
        },
        show() {
            this.init();

            this.visibility = true;
            this.treeNode = this.$refs.tree;

            setTimeout(() => {
                this.searchInTree();
            }, 0);
        },
        hide() {
            this.setText();
            this.visibility = false;
        },
        $validate(isError, callback, msg) {
            if (!this.isValidate) return false;
            let cb = typeof callback === 'function' ? callback : undefined;
            if (this.inputValue) {
                this.isError = isError;
                isError ? cb && cb(msg) : cb && cb('');
            } else {
                this.isError = true;
                this.$message.error(this.requiredMsg);
                cb && cb(this.requiredMsg);
            }
        },

        $reset() {
            this.isError = false;
            this.inputValue = '';
            this.selected = null;
            // 触发input事件，保持input事件传递id，以支持v-model的使用。
            this.$emit('input', '');
            // 添加选择节点select-node事件，用于传递node节点，实现多种传值方式。
            this.$emit('select-node', {});
            this.$refs.tree.reset();
        }
    }
};
</script>

<style lang="scss" scoped>
.tree-selectinput-wrapper {
    position: relative;
}

.float-box {
    position: absolute !important;
    top: 110%;
    background: #fff;
    width: 200%;
    max-width: 400px;
    padding: 10px;
    box-sizing: border-box;
    min-height: 50px;
    max-height: 250px;
    overflow-y: scroll;
    border: 1px solid #e4e7ed;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    z-index: 1000;
}
</style>
